module.exports = __webpack_public_path__ + "static/media/ico-calendar.eddd8f91.svg";